<div class="title">
    Edit Device
</div>

<form (submit)="submit($event)">
    <mat-form-field>
        <input matInput
               [formField]="deviceForm.alias"
               placeholder="Device alias">
        <mat-error>
            <app-field-errors [formField]="deviceForm.alias"></app-field-errors>
        </mat-error>
    </mat-form-field>

    <div class="actions">
        <button mat-raised-button
                color="primary"
                [disabled]="!canSubmit()"
                type="submit"
                mat-dialog-close="">Submit</button>
        <button mat-raised-button
                type="button"
                mat-dialog-close="">Cancel</button>
    </div>
</form>
